import { BreakpointObserver } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'ts-types-page',
  templateUrl: './types-page.component.html',
  styleUrls: ['./types-page.component.scss'],
})
export class TypesPageComponent {
  showMobileLayout$: Observable<boolean> = this._breakpoint.observe(['(max-width: 420px)']).pipe(map((_) => _.matches));

  constructor(private _breakpoint: BreakpointObserver) {}
}
